import { gql } from '@apollo/client';

const ONBOARDING_STATUS_FIELDS = `
  completed
  progressPercentage
  completedStepsCount
  totalStepsCount
  steps {
    step
    label
    description
    completed
    skipped
    autoCompleted
    completedAt
    skippedAt
    metadata
  }
`;

export const GET_ACCOUNT_ONBOARDING_STATUS = gql`
  query GetAccountOnboardingStatus {
    accountOnboardingStatus {
      ${ONBOARDING_STATUS_FIELDS}
    }
  }
`;

export const COMPLETE_ACCOUNT_ONBOARDING_STEP = gql`
  mutation CompleteAccountOnboardingStep($step: String!) {
    completeAccountOnboardingStep(input: { step: $step }) {
      onboardingStatus {
        ${ONBOARDING_STATUS_FIELDS}
      }
      errors
    }
  }
`;

export const SKIP_ACCOUNT_ONBOARDING_STEP = gql`
  mutation SkipAccountOnboardingStep($step: String!) {
    skipAccountOnboardingStep(input: { step: $step }) {
      onboardingStatus {
        ${ONBOARDING_STATUS_FIELDS}
      }
      errors
    }
  }
`;

export const RESET_ACCOUNT_ONBOARDING_STEP = gql`
  mutation ResetAccountOnboardingStep($step: String!) {
    resetAccountOnboardingStep(input: { step: $step }) {
      onboardingStatus {
        ${ONBOARDING_STATUS_FIELDS}
      }
      errors
    }
  }
`;

export const SKIP_ACCOUNT_ONBOARDING = gql`
  mutation SkipAccountOnboarding {
    skipAccountOnboarding(input: {}) {
      onboardingStatus {
        ${ONBOARDING_STATUS_FIELDS}
      }
      errors
    }
  }
`;
